import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";

export const addAxiosErrorToContextAction = (
  context: TransactionWizardContext,
  event: TransactionWizardEvent
) => {
  if (event.type !== "SOMETHING_WRONG") return {};

  return {
    error: event.error?.response?.data,
  };
};
